import { SwitchingBlankEditorContent } from "shared/pageContent/SwitchingBlankEditorContent";
import Layout from "../../components/mainPage/Layout";


export function Page() {
    return (
        <Layout>
            <SwitchingBlankEditorContent />
        </Layout>
    );
}